import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchDigestHistory } from "../api/digest";
import { DigestPeriodTabs } from "../components/digest/DigestPeriodTabs";
import { DigestReport } from "../components/digest/DigestReport";
import { ErrorBlock, LoadingBlock } from "../components/QueryStatus";

export function DigestPage() {
  const { data, isPending, isError } = useQuery({
    queryKey: ["dashboard", "digest-history"],
    queryFn: () => fetchDigestHistory(),
  });
  const [selectedKey, setSelectedKey] = useState<string | null>(null);

  if (isPending) return <LoadingBlock label="Loading periodic digest" surface="canvas" />;
  if (isError || !data || data.length === 0)
    return <ErrorBlock message="Could not load the periodic digest." surface="canvas" />;

  const activeKey = selectedKey ?? data[0].period_key;
  const activeIndex = data.findIndex((p) => p.period_key === activeKey);
  const period = data[Math.max(0, activeIndex)];
  const previousPeriod = data[Math.max(0, activeIndex) + 1];

  return (
    <div className="space-y-6">
      <div>
        <div className="eyebrow">Periodic Report</div>
        <h2 className="mt-1 text-lg font-semibold text-zinc-900">Periodic Digest</h2>
        <p className="mt-1 text-sm text-zinc-500">
          An auto-generated summary of newly surfaced claim candidates, refreshed each period. Browse prior periods
          below.
        </p>
      </div>

      <DigestPeriodTabs periods={data} selectedKey={activeKey} onSelect={setSelectedKey} />

      <DigestReport period={period} previousPeriod={previousPeriod} />
    </div>
  );
}
